import { useState, useEffect } from 'react';
import { PATH_NAMES, QUERY_PARAMS } from './constants';

const useQueryParams = () => {
  const [params, setParams] = useState({
    queryCabinet: '',
    cabinetPath: ''
  });

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const urlParams = new URLSearchParams(window.location.search);
      const cabinet = urlParams.has(QUERY_PARAMS.CABINET) ? urlParams.get(QUERY_PARAMS.CABINET) : '';
      const pathname = window.location.pathname;
      const path = pathname.includes(PATH_NAMES.CABINET) ? pathname : '';

      // Single state update = single render
      setParams({ queryCabinet: cabinet, cabinetPath: path });
    }
  }, []);

  return [params.queryCabinet, params.cabinetPath];
};

export default useQueryParams;